import { Component } from 'react';
import { Quill } from 'react-quill';
import _ from 'lodash';

var Parchment = Quill.import('parchment');
var Delta = Quill.import('delta');
let Break = Quill.import('blots/break');
let Embed = Quill.import('blots/embed');
let Block = Quill.import('blots/block');

function lineBreakMatcher() {
  var newDelta = new Delta();
  newDelta.insert({'break': ''});
  return newDelta;
}

var options = {
  clipboard: {
    matchers: [
      ['BR', lineBreakMatcher] 
    ]
  },
  keyboard: {
    bindings: {
      tab: {
        key: 9,
        handler: function (range, context) {
          // Handle tab
          // Tab size = 20
          if (context.offset === 0 || context.prefix.match(/^\s+$/)){
            this.quill.insertText(range.index, String.fromCharCode(9));
          }else{
            var i;
            for (i = 0; i <= 19; i++) { 
              this.quill.insertText(range.index + i, String.fromCharCode(160));
            }
          }
        }
      }

    }
  }
};

Break.prototype.insertInto = function(parent, ref) {
    Embed.prototype.insertInto.call(this, parent, ref)
};
Break.prototype.length= function() {
    return 1;
}
Break.prototype.value= function() {
    return '\n';
}

class QuillShiftEnter extends Component {
  get optionsConfig() {
    return _.merge(options, {toolbar: true})
  }

  get hiddenToolbarConfig() {
    return _.merge(options, {toolbar: false})
  }
}

export default new QuillShiftEnter();


// WEBPACK FOOTER //
// ./src/components/QuillShiftEnter.js